// extracted by mini-css-extract-plugin
export default {"modal":"NavModal_modal__OEwAE","overlay":"NavModal_overlay__OaSgH","navLinks":"NavModal_navLinks__4GOzU"};